import { render, staticRenderFns } from "./SchoolLocationsDetails.vue?vue&type=template&id=77c3a9e4&"
import script from "./SchoolLocationsDetails.vue?vue&type=script&lang=js&"
export * from "./SchoolLocationsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports